@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}

@if (windowService?.isDesktopRes) {
  <tidy-desktop-header #listingsHeader>
    <div class="wrappable-container">
      <tidy-text [header]="'Listings'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search"
          [showClearButton]="true"
          (clear)="clearSearch()" />
      </form>
      @if (showListingsSetup) {
        <tidy-small-button
          [text]="'Tell Us About Your Listings'"
          (buttonClick)="goToListingsSetup()" />
      }
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'listings'" />
    </div>
  </tidy-desktop-header>
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (windowService?.isDesktopRes && !loaded) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (windowService?.isDesktopRes && loaded && rows.length === 0) {
  <tidy-alert>
    <tidy-row>
      <tidy-text [body]="'No listings connected yet.'" />
    </tidy-row>
  </tidy-alert>
}

@if (windowService?.isDesktopRes && loaded && rows.length > 0) {
  <tidy-table
    [dataSource]="rows"
    [displayedColumns]="headers"
    [columnslabels]="headers"
    [showColumnLines]="false"
    [rowsToShow]="50"
    [allRowIsClickable]="true"
    [skipEntrance]="true"
    (sortChange)="sortChanged($event)"
    (cellClick)="onTableColumnClick($event)"
    [infiniteScroll]="true"
    [totalRows]="rows.length" />
}

@if (!windowService?.isDesktopRes && loaded) {
  <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 10px;">
    <div style="flex: 1; min-width: 0;">
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search"
          [showClearButton]="true"
          (clear)="clearSearch()" />
      </form>
    </div>
    @if (showListingsSetup) {
      <tidy-small-button
        [text]="'Tell Us About Your Listings'"
        (buttonClick)="goToListingsSetup()" />
    }
  </div>
  @for (row of rows; track $index) {
    <tidy-card>
      <tidy-card-button (action)="onTableColumnClick({ column: '', element: row })" class="arrow-to-top">
        <tidy-row class="vertical-align-center">
          <ion-icon name="home" [style.color]="row['Property'].color || '#1E2125'" style="font-size: 16px; margin-right: 4px;" />
          <tidy-text [header]="row['Property'].value" [translate]="false" />
        </tidy-row>
        <tidy-row>
          <!-- statusLabel, not the Status cell — that value carries the dot markup. -->
          <tidy-text [body]="row['Platform'].value + ' (' + row.statusLabel + ')'" [translate]="false" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
  }
  @if (rows.length === 0) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="'No listings connected yet.'" />
      </tidy-row>
    </tidy-alert>
  }
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'listings'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
